import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const loginUser = (params) => {
  return Api(endPoints.loginAgent, params, requestType.POST);
};

const logoutUser = () => {
  return Api(endPoints.logout, {}, requestType.POST);
};

const createAgent = (_, params) => {
  return Api(endPoints.registerAgent, params, requestType.POST);
};

const getAllAgents = () => {
  return Api(endPoints.getAllAgents, null, requestType.GET);
};

const getAllAdmin = () => {
  return Api(endPoints.getAllAdmin, null, requestType.GET);
};

const updateAgent = (id, params) => {
  return Api(`${endPoints.updateAgent}/${id}`, params, requestType.PUT);
};

const deleteAgent = (id, params) => {
  return Api(`${endPoints.deleteAgent}/${id}`, params, requestType.DELETE);
};

const agentMarkOffDays = (id, params) => {
  return Api(`${endPoints.agentMarkDaysOff}/${id}`, params, requestType.PUT);
};
const agentMarkDaysOffForAll = (params) => {
  return Api(endPoints.agentMarkDaysOffForAll, params, requestType.POST);
};

const getAgentOffDays = (id) => {
  return Api(`${endPoints.getAgentOffDays}/${id}`, null, requestType.GET);
};

const getAgentOffDaysForAll = (id) => {
  return Api(endPoints.getAgentOffDays, null, requestType.GET);
};

const agentRemoveOffDays = (id, params) => {
  return Api(
    `${endPoints.agentRemoveOffDays}/${id}`,
    params,
    requestType.DELETE
  );
};

const getAllAgentsReport = (query) => {
  let url = `${endPoints.agentReport}?startDate=${query.startDate}&endDate=${query.endDate}`;

  if (query?.ids && query?.ids.length > 0) {
    url += `&id=${query?.ids.join(",")}`;
  }
  if (query?.searchBy?.trim()) {
    url += `&searchBy=${query.searchBy}`;
  }

  return Api(url, null, requestType.GET);
};

const getAdminAgentDetails = (id, fields) => {
  let url = `${endPoints.getAdminAgentDetails}/${id}`;

  if (fields) {
    url += `?fields=${fields}`;
  }

  return Api(url, null, requestType.GET);
};



export {
  loginUser,
  logoutUser,
  createAgent,
  getAllAgents,
  updateAgent,
  deleteAgent,
  agentMarkOffDays,
  getAgentOffDays,
  agentRemoveOffDays,
  getAllAdmin,
  agentMarkDaysOffForAll,
  getAgentOffDaysForAll,
  getAllAgentsReport,
  getAdminAgentDetails,
};
